export default function ErrorPage () {

return (

<h1>Error Page</h1>

);

}